import { Skeleton } from '@mantine/core'

import { SectionInfoIcon } from 'src/components/Feedback/SectionInfoIcon/SectionInfoIcon'

export interface VoEAnalyticsCardProps {
  title: string
  subtitle?: string
  info?: string
  loading?: boolean
  headerRight?: React.ReactNode
  children: React.ReactNode
}

export const VoEAnalyticsCard = ({
  title,
  subtitle,
  info,
  loading = false,
  headerRight,
  children,
}: VoEAnalyticsCardProps) => {
  const isEmpty = !children || (Array.isArray(children) && children.length === 0)

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-5">
      <div className="mb-4 flex items-start justify-between">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-base font-semibold text-gray-900">{title}</h3>
            {info && <SectionInfoIcon tooltip={info} />}
          </div>
          {subtitle && (
            <p className="mt-0.5 text-sm text-gray-500">{subtitle}</p>
          )}
        </div>
        {headerRight && <div>{headerRight}</div>}
      </div>

      {loading ? (
        <div className="flex flex-col gap-3">
          <Skeleton height={20} width="80%" />
          <Skeleton height={270} />
        </div>
      ) : isEmpty ? (
        <div className="flex h-[300px] items-center justify-center text-sm text-gray-400">
          No data available
        </div>
      ) : (
        children
      )}
    </div>
  )
}
